import * as moment from 'moment';

export function prettyDate(date: Date): string {
  return moment.utc(date).local().format('M/D/YYYY LT');
}

export function fromNow(date: Date, noSuffix: boolean = false): string {
  return moment.utc(date).fromNow(noSuffix);
}
